// src/pages/workout/condition_guide/MSKExerciseGuide/video.jsx
import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthCard from "../../../../../components/auth/AuthCard";
import BottomNav from "../../../../../components/common/BottomNav";
import { useLoadingGate } from "../../../../../hooks/useLoadingGate";
import { VIDEOS_BY_ITEM } from "../../../../../data/videos/mskVideos";


const TITLES = {
    "straight-neck": "일자목 운동",
    "cervical-disc": "경추디스크 운동",
    "opf": "후종인대골화증 운동",
    "neck-rehab-1": "목 재활 운동 1단계",
    "neck-rehab-2": "목 재활 운동 2단계",
    "neck-rehab-3": "목 재활 운동 3단계",
    "neck-rehab-4": "목 재활 운동 4단계",
};

// 한글 제목 → key 역매핑
const TITLE_TO_KEY = Object.fromEntries(
    Object.entries(TITLES).map(([k, v]) => [v, k])
);

export default function MSKVideoList() {
    const ready = useLoadingGate();
    const navigate = useNavigate();
    const [sp] = useSearchParams();

    // 쿼리 읽기
    const catQuery = sp.get("cat") || "";
    const itemQuery = sp.get("item") || "";
    const titleQuery = sp.get("title");

    const itemKey = useMemo(() => {
        if (itemQuery && VIDEOS_BY_ITEM[itemQuery] !== undefined) return itemQuery;
        if (TITLE_TO_KEY[itemQuery]) return TITLE_TO_KEY[itemQuery];
        if (itemQuery) return itemQuery;
        return "straight-neck";
    }, [itemQuery]);

    const list = useMemo(
        () => (itemKey ? VIDEOS_BY_ITEM[itemKey] ?? [] : []),
        [itemKey]
    );

    const title = TITLES[itemKey] || titleQuery || "운동 영상";

    return (
        <main className="h-[var(--app-height)] flex flex-col font-suit overflow-y-auto scrollbar-hide px-7 md:px-8 bg-white">
            {!ready ? (
                <div className="flex-1" />
            ) : (
                <AuthCard
                    className="flex-1 w-full mx-auto"
                    title={title}
                    onClose={() => navigate(-1)}
                >
                    <div className="flex flex-col flex-1 pt-3 md:pt-4 pb-24 md:pb-28">
                        <ul className="grid grid-cols-2 gap-3 md:gap-4 ">
                            {list.map((v) => (
                                <li key={v.id}>
                                    <button
                                        type="button"
                                        className="w-full rounded-2xl bg-white transition"
                                        onClick={() => {
                                            const qs = new URLSearchParams({
                                                v: v.id,
                                                cat: catQuery,
                                                item: itemKey || itemQuery,
                                                title: v.title, // 상세 상단 제목

                                            }).toString();
                                            navigate(`/workout/conditionguide/msk/video/detail?${qs}`, {
                                                state: {
                                                    title: v.title,
                                                    poster: v.thumb,
                                                    guide: Array.isArray(v.guide) ? v.guide : (v.guide ? [v.guide] : []),
                                                },
                                            });

                                        }}
                                    >
                                        <div className="aspect-video w-full rounded-xl overflow-hidden border border-[#F1F1F1]">
                                            {v.thumb ? (
                                                <img
                                                    src={v.thumb}
                                                    alt={v.title}
                                                    className="w-full h-full object-cover"
                                                    loading="lazy"
                                                />
                                            ) : (
                                                <div className="w-full h-full bg-gray-100" />
                                            )}
                                        </div>

                                        <div className="py-2">
                                            <p className="text-sm md:text-base font-medium leading-tight line-clamp-2 text-center">
                                                {v.title}
                                            </p>
                                        </div>
                                    </button>
                                </li>
                            ))}
                            {list.length === 0 && (
                                <li className="col-span-2 text-center text-gray-500 py-10">
                                    준비된 영상이 없습니다.
                                </li>
                            )}
                        </ul>
                    </div>
                </AuthCard>
            )}
            <BottomNav className="h-16 md:h-[72px]" />
        </main>
    );
}
